import { msalInstance } from '@/plugins/msal';
import router from '../router';
import store from '../store';
import { clearAllSessionData } from '../utils/sessionCleanup';

const ACCESS_SCOPE = 'https://hygiasotest.onmicrosoft.com/0bbcbac3-434f-404d-9870-f4cfd903531e/access_as_user';

export async function login() {
    try {
        const accounts = msalInstance.getAllAccounts();
        const interactionInProgress = sessionStorage.getItem("msal.interaction.status") === "interaction_in_progress";
        if (!interactionInProgress && accounts.length === 0) {
            await msalInstance.loginRedirect({
                scopes: [ACCESS_SCOPE],
            });
        }
    } catch (error) {
        console.error("Login error:", error);
    }
}

export async function logout() {
    try {
        console.log('🔑 Starting MSAL logout...');
        
        // Clear all session data first
        clearAllSessionData();
        
        // Clear MSAL cache before logout
        msalInstance.clearCache();
        console.log('✅ MSAL cache cleared');
        
        // Redirect user to a safe route before logout
        router.push("/landing");
        
        // Perform MSAL logout
        await msalInstance.logoutRedirect();
        console.log('✅ MSAL logout redirect initiated');
    } catch (error) {
        console.error("Logout error:", error);
        // Even if logout fails, we should still clear the cache
        try {
            msalInstance.clearCache();
        } catch (cacheError) {
            console.error("Failed to clear MSAL cache:", cacheError);
        }
        // throw error;
    }
}

export function isAuthenticated() {
    return msalInstance.getAllAccounts().length > 0;
}

export async function handleAuthResponse() {
    try {
        await msalInstance.handleRedirectPromise();
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
            store.dispatch("user/populateUserDetails");
        }
    } catch (error) {
        console.error("Auth response handling error:", error);
    }
}

export async function getToken() {
    if (!msalInstance) {
        throw new Error('Auth not initialized');
    }

    const account = msalInstance.getAllAccounts()[0];
    if (!account) {
        throw new Error('No active account');
    }

    try {
        const response = await msalInstance.acquireTokenSilent({
            scopes: [ACCESS_SCOPE],
            account: account,
        });
        return response.accessToken;
    } catch (error) {
        console.error('Token acquisition failed:', error);
        logout();
    }
}